// import XLSX from 'xlsx';
// import json2csv from 'json2csv';
// import FileSaver from 'file-saver';
import config from '../resource/config.js'
//import appConfig from '../resource/appConfig.js';
// var path = require('path');

const downloadapi = config.apiBaseUrl + 'apbe/logfiledownloader'


// function s2ab(s) {
//     var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
//     var view = new Uint8Array(buf);  //create uint8array as viewer
//     for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
//     return buf;
// }

export default class download {



    handleclick(requestId, cognitoId, apiAuthHeaders) {
            let presignedUrl = true
            fetch(downloadapi, {
                method: 'POST',
                dataType: 'jsonp',
                headers: apiAuthHeaders,
                body: JSON.stringify({ requestId,cognitoId, presignedUrl })
            }).then((response) => {
                return response.json()
            }).then((responseData) => {
                if(responseData.data == null){
                    console.log("Here is the presigned URL: " + JSON.stringify(responseData))
                    window.open(responseData, '_blank')
                    // document.getElementById("downloadloglink").href = JSON.stringify(responseData);
                    // document.getElementById('downloadloglink').click()
                }

            }).catch(function (err) {
                console.log(err)
            })

    }

}

//console.log("FileType", this.props.PassDataItems.FILE_TYPE
